import { render, staticRenderFns } from "./SignUp1.vue?vue&type=template&id=d949c152&"
import script from "./SignUp1.vue?vue&type=script&lang=js&"
export * from "./SignUp1.vue?vue&type=script&lang=js&"
import style0 from "./SignUp1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports